import applicationNotification from 'screens/Applications&WorkOrders/Applications/Components/Notification';
import { ExportLanguageEnum } from 'screens/Applications&WorkOrders/Hooks/useOperationPdf';
import { OperationType } from 'components/RecordsListView/constants';
import { ApplicationDetails } from 'screens/Applications&WorkOrders/Applications/Hooks/useApplication';
import useQueuedPdfDownload from 'components/LinkedRecordOverviewDrawer/useQueuedPdfDownload';

interface UseDrawerPdfDownloadParams {
  operation: ApplicationDetails | undefined;
  userId: string;
  isOpen: boolean;
  hasFailed?: boolean;
}

const useDrawerPdfDownload = ({
  operation,
  userId,
  isOpen,
  hasFailed = false
}: UseDrawerPdfDownloadParams) =>
  useQueuedPdfDownload({
    record: operation,
    operationType: OperationType.APPLICATION,
    userId,
    isOpen,
    hasFailed,
    onError: () => applicationNotification('PDF_EXPORT_ERROR', () => {}),
    renderPdf: ({ createPDF }, record) =>
      createPDF(record as any, ExportLanguageEnum.ENGLISH, false)
  });

export default useDrawerPdfDownload;
